export const lightPalette = {
  primary: {
    main: "#431e5b",
    light: "#E6E2F8",
    dark: "#672c900D",
  },
  secondary: {
    main: "#FFFFFF",
  },
  info: {
    main: "#E6E2F8",
  },
  background: {
    default: "#FFFFFF",
    paper: "#A2A1A80D",
    light: "rgba(162,161,168,0.2)",
  },
  text: {
    primary: "#000000",
    gray: "#A2A1A8",
  },
  error: {
    main: "#F45B69",
    dark: "#F45B6919",
    light: "#FEEFF0",
  },
  warning: {
    main: "#EFBE12",
    dark: "#EFBE1219",
    light: "#FDF8E7",
  },
  success: {
    main: "#3FC28A",
    dark: "#3FC28A19",
    light: "#ECF9F3",
  },
  expense: {
    water: {
      background: "rgba(21,101,192,0.1)",
      primary: "#1565C0",
    },
    paper: {
      background: "#F3E5D8",
      primary: "#8D6E63",
    },
    increment: {
      background: "#CFF3D8FF",
      primary: "#3a5d46",
    },
    coffee: {
      background: "#EFEBE9",
      primary: "#4E342E",
    },
    chemistry: {
      background: "#E8F5E9",
      primary: "#1B5E20",
    },
    other_equipment: {
      background: "#EEEEEE",
      primary: "#424242",
    },
    fresheners: {
      background: "#FCE4EC",
      primary: "#AD1457",
    },
    garbage_bags: {
      background: "#F5F5F5",
      primary: "#616161",
    },
    soap: {
      background: "#E1F5FE",
      primary: "#0277BD",
    },
    batteries: {
      background: "#FFF9C4",
      primary: "#FBC02D",
    },
    juices_candies: {
      background: "#FFF3E0",
      primary: "#EF6C00",
    },
    computer_equipment: {
      background: "#EDE7F6",
      primary: "#4527A0",
    },
    food: {
      background: "#FFF8E1",
      primary: "#FF6F00",
    },
    other: {
      background: "rgba(189,189,189,0.6)",
      primary: "#424242",
    },
  },
};
export const darkPalette = {
  primary: {
    ...lightPalette.primary,
  },
  secondary: {
    main: "#FFFFFF",
  },
  info: {
    main: "#A2A1A8",
    light: "#A2A1A80D",
  },
  background: {
    default: "#16151C",
    paper: "#A2A1A80D",
    light: "rgba(162, 161, 168, 0.2)",
  },
  text: {
    primary: "#FFFFFF",
    gray: "#A2A1A8",
  },
  error: lightPalette.error,
  warning: lightPalette.warning,
  success: lightPalette.success,
  expense: {
    water: {
      background: "#102027",
      primary: "#42A5F5",
    },
    paper: {
      background: "#2D211C",
      primary: "#BCAAA4",
    },
    increment: {
      background: "#243a2c",
      primary: "#CFF3D8FF",
    },
    coffee: {
      background: "#2E2724",
      primary: "#8D6E63",
    },
    chemistry: {
      background: "#1A2B1A",
      primary: "#66BB6A",
    },
    other_equipment: {
      background: "#212121",
      primary: "#BDBDBD",
    },
    fresheners: {
      background: "#31102E",
      primary: "#EC407A",
    },
    garbage_bags: {
      background: "#1C1C1C",
      primary: "#9E9E9E",
    },
    soap: {
      background: "#102B3A",
      primary: "#4FC3F7",
    },
    batteries: {
      background: "#2C260D",
      primary: "#FFD740",
    },
    juices_candies: {
      background: "#2C1908",
      primary: "#FFB74D",
    },
    computer_equipment: {
      background: "#1B1524",
      primary: "#9575CD",
    },
    other: {
      background: "rgba(66,66,66,0.8)",
      primary: "#BDBDBD",
    },
    food: {
      background: "rgba(255,143,0,0.2)",
      primary: "#FFB300",
    },
  },
};
